import { Button, Icon, Modal, Text, VStack } from '@genial/components';
import { Modal as NativeModal } from 'native-base';
import React from 'react';

export interface TermGracePeriodModalProps {
  isOpen: boolean;
  gracePeriodEndDateNormalized: string;
  onClose: () => void;
}

export const TermGracePeriodModal: React.FC<TermGracePeriodModalProps> = ({
  isOpen,
  gracePeriodEndDateNormalized,
  onClose,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} testId="fixed-fee-term-grace-period-modal">
      <NativeModal.Content
        alignItems="center"
        w="full"
        maxW={{ base: 'full', lg: '560px' }}
        marginBottom={{ base: 0, lg: 'none' }}
        marginTop={{ base: 'auto', lg: 0 }}>
        <VStack w="full" px="inline.xs" py="inline.xs" space="stack.xxxs" alignItems="center">
          <Icon name="Info" size="md" color="brand.primary.principal" />

          <Text variant="semibold" textAlign="center" fontSize="lg">
            Termo em período de permanência.
          </Text>

          <Text textAlign="center" maxW="2/3">
            Este termo não poderá ser encerrado ou substituído antes de{' '}
            {gracePeriodEndDateNormalized}.
          </Text>

          <Button w="full" variant="primary" onPress={onClose} maxW="1/2">
            Entendi
          </Button>
        </VStack>
      </NativeModal.Content>
    </Modal>
  );
};
